<div class="layout-bottom-bar  overflow-x-auto" >
    
    <div class="flex justify-content-around align-items-center text-center">
        <div v-for="(item, index) in menu_items" :key="index" 
            class="flex align-items-center justify-content-center">
            <app-sub-menu :menu="item"></app-sub-menu>
        </div>
    </div>
</div>